import { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

import BaseModal from 'components/modules/BaseModal';

/** ボタンローディング時間（ミリ秒） */
const CLOSE_BUTTON_LOADING_DURATION_MS = 2500;

/**
 * RecoveryCodeModalのプロパティ型
 */
interface RecoveryCodeModalProps {
    /** モーダルを閉じる関数 */
    handleClose: () => void;
    /** モーダルの開閉状態 */
    isOpen: boolean;
}

/**
 * リカバリーコードを表示するモーダルコンポーネント
 * 2要素認証設定完了後に表示され、リカバリーコードをコピー・保存できる
 * @param {RecoveryCodeModalProps} props - コンポーネントのプロパティ
 */
export const RecoveryCodeModal = ({
    handleClose,
    isOpen,
}: RecoveryCodeModalProps) => {
    /** ボタンローディング状態 */
    const [isLoading, setIsLoading] = useState<boolean>(false);

    /** タイマーのref（クリーンアップ用） */
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    // モーダルの開閉に応じてローディング状態を管理する
    useEffect(() => {
        if (!isOpen) {
            setIsLoading(false);
            return;
        }
        // モーダルが開いた時に指定時間ローディング状態にする
        setIsLoading(true);
        timerRef.current = setTimeout(() => {
            setIsLoading(false);
        }, CLOSE_BUTTON_LOADING_DURATION_MS);

        return () => {
            if (timerRef.current !== null) {
                clearTimeout(timerRef.current);
            }
        };
    }, [isOpen]);

    // ローディング中はモーダルを閉じないようにガード
    const onClose = () => {
        if (isLoading) return;
        handleClose();
    };

    return (
        <BaseModal
            onCancel={onClose}
            visible={isOpen}
            footer={
                <div>
                    <Button onClick={onClose} loading={isLoading}>閉じる</Button>
                </div>
            }
        >
            <div className='container flex-col items-center justify-center h-full gap-4'>
                <div
                    className='flex items-center justify-center'
                    style={{
                        backgroundColor: '#52c51b',
                        borderRadius: '50%',
                        width: 64,
                        height: 64,
                    }}
                >
                    <CheckOutlined style={{ fontSize: 32, color: '#fff' }} />
                </div>
                <p className='text-center text-xl'>登録が完了しました</p>
            </div>
        </BaseModal>
    );
};
